/**
 * Digital employees sold as ready-made processes (Laplace 2.0).
 * Each key owns an isolated backend module and frontend feature.
 */
export var EmployeeKey;
(function (EmployeeKey) {
    EmployeeKey["GTM"] = "gtm";
})(EmployeeKey || (EmployeeKey = {}));
//# sourceMappingURL=employee-key.enum.js.map